import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

function Simple(props) {
    const { t, i18n } = useTranslation();

    const { 
      inputParam_Item = null,
      inputParam_ItemFields = null,
    } = props;

    return (
              <Row className="justify-content-end">
              {
                inputParam_Item.l_vals.map((val, indexVal) => (
                  <fieldset key={indexVal} className="border-bottom">
                    <Row className="p-0 m-0">
                      {
                        inputParam_ItemFields && inputParam_ItemFields.map((_field, index) => (
                          <Col key={index} className="p-0 m-0">
                            <Card className="p-0 m-0">
                                <Card.Body className='p-0 m-0 text-center rounded-top' style={{backgroundColor: "gray", color: "white", height: "20px !important"}}>
                                  <b>{ t(`data-lang-lbl-field-${_field.field}`) }</b>
                                </Card.Body>
                                <Card.Body className={`pt-1 pb-0 rounded-bottom text-center ${ "variable-text-color-" + val.color }`}>
                                  {`${val[_field.field] !== undefined && !isNaN(val[_field.field]) ? (val[_field.field] !== null ? (_field.field !== 'serieTime' ? parseFloat(val[_field.field]).toLocaleString(i18n.language) : val[_field.field]) + (_field.simbol !== null ? _field.simbol : ""): t('no-data')) : t('no-data')}`}
                                </Card.Body>
                            </Card>
                          </Col>
                        )) 
                      }
                    </Row>
                  </fieldset>
                ))   
              }
              </Row>
            );
}

Simple.propTypes = {
  inputParam_Item: PropTypes.object.isRequired,
  inputParam_ItemFields: PropTypes.array.isRequired,
};

export default Simple;